// Web shim for react-native-pager-view.
// JobsScreen guards `Platform.OS !== 'web'` before rendering this on web,
// so this stub is only here to satisfy the import. Renders children in a
// plain View; setPage on the ref is a no-op.
import React, { forwardRef, useImperativeHandle } from 'react';
import { View, ViewStyle } from 'react-native';

interface PagerViewProps {
  children?: React.ReactNode;
  style?: ViewStyle | ViewStyle[];
  initialPage?: number;
  onPageSelected?: (e: { nativeEvent: { position: number } }) => void;
}

export interface PagerViewRef {
  setPage: (page: number) => void;
}

const PagerView = forwardRef<PagerViewRef, PagerViewProps>(
  ({ children, style }, ref) => {
    useImperativeHandle(ref, () => ({ setPage: () => {} }));
    return <View style={style}>{children}</View>;
  },
);

PagerView.displayName = 'PagerView';

export default PagerView;
